<template>
  <img
    :src="addChatIcon"
    @click.prevent="click"
    class="month-view-cal split-icon-header"
    alt="img"
  />
</template>

<script>
export default {
  data() {
    return {
      addChatIcon: require("../../assets/svg/add-chat-bg-fill.svg")
    };
  },
  props: {
    click: Function
  }
};
</script>

<style scoped>
img {
  width: 22px !important;
}
</style>
